import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent{
  Email: string = '';

  constructor(
    private r: Router,  
    private email: AuthService,
    private fb: FormBuilder,
    private tstr: ToastrService 
  ) {}

  signInForm = this.fb.group({
    email: ['', Validators.required]
  })

  forgetPassword() {
    this.email.emailRes = this.signInForm.value['email']
    this.email.emailService(this.signInForm.value)
    .subscribe({
      next: (result) => {
        if(result.status == true) {
          this.tstr.success('OTP has been sent to your email address')
          this.r.navigate(['forgetPasswordDetails']);
        } else if (result.status == 'error') {
          this.tstr.error(result.message)
        }else {
          this.tstr.error(result.message)
        }
    }, 
  })
}
}



